import {
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
  OnDestroy,
  AfterViewInit,
  Input,
} from "@angular/core";
import { GroupDto, SubGroupDto, SubSubGroupDto } from "@cradua/data";
import { fromEvent, Subscription } from "rxjs";
import {
  debounceTime,
  distinctUntilChanged,
  map,
  pluck,
  tap,
} from "rxjs/operators";

@Component({
  selector: 'cradua-address-book-search',
  templateUrl: './address-book-search.component.html',
  styleUrls: ['./address-book-search.component.scss']
})
export class AddressBookSearchComponent implements OnInit {
  @Input() subSubGroups: SubSubGroupDto[];
  @Input() subGroups: SubGroupDto[];
  @Input() groups: GroupDto[];
  @Input() task: string;
  @Input() view: string;
  @Output() searchEmit = new EventEmitter<any>();
  @Output() emitEvent = new EventEmitter<any>();
  @Output() emitTask = new EventEmitter<any>();

  @ViewChild("search", { static: true })
  searchForm: ElementRef;
  searchSubscription$: Subscription;
  filterSubGroup: SubGroupDto[];
  filterSubSubGroup: SubSubGroupDto[];
  selectedGroupId = "";
  selectedSubGroupId = "";
  selectedSubSubGroupId = "";
  isFilter = false;
  constructor() {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.searchSubscription$ = fromEvent(this.searchForm.nativeElement, "keyup")
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        pluck("target", "value"),
        tap(_ => this.task === 'list' ? null : this.emitTask.emit('list')),
        // filter((searchTerm: string) => searchTerm.length > 2),
        map((value) => value),
      )
      .subscribe((data) => this.searchEmit.emit(data));
  }

  protected filterById = <T>(id: string, lookupId: string) =>
    (fieldName: T) => fieldName[lookupId] === id;


  createEvent() {
    this.emitTask.emit('create')
  }

  onFilter() {
    this.isFilter = !this.isFilter;
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    if (this.searchSubscription$) {
      this.searchSubscription$.unsubscribe();
    }
  }

}
